import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Header } from '../components/Header';
import { toast } from 'react-toastify';
import { API_BASE, apiFetch } from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import WaveBackground from '../components/WaveBackground';

const Footer = () => (
    <></>
);

export default function Home() {
    const [loginCode, setLoginCode] = useState('');
    const [showCode, setShowCode] = useState(false);
    const navigate = useNavigate();
    const { status, user, refreshAuth } = useAuth();

    useEffect(() => {
        if (status !== 'loading' && user) {
            navigate('/chat', { replace: true });
        }
    }, [navigate, status, user]);

    const handleStart = async () => {
        if (loginCode.trim()) {
            try {
                const res = await apiFetch(`${API_BASE}/api/auth/login`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ code: loginCode.trim() }),
                });

                if (!res.ok) {
                    const data = await res.json().catch(() => ({}));
                    toast.error(data?.message ?? 'Invalid login code');
                    return;
                }

                await refreshAuth();
                navigate('/chat', { replace: true });
            } catch {
                toast.error('Unable to login right now');
            }
        }
    };

    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            handleStart();
        }
    };

    return (
        <div className="flex flex-col min-h-screen" style={{ position: 'relative' }}>
            <WaveBackground />
            {/* All content sits above the canvas */}
            <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                <Header />
                <main className="flex flex-col items-center justify-center flex-grow">
                    <div className="p-8 rounded-lg w-full max-w-md" style={{
                        background: 'rgba(255,255,255,0.08)',
                        backdropFilter: 'blur(16px)',
                        WebkitBackdropFilter: 'blur(16px)',
                        border: '1px solid rgba(255,255,255,0.18)',
                        boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
                    }}>
                        <h1 className="text-3xl font-bold text-center mb-6" style={{ color: '#fff' }}>
                            Filtron's Agentic AI
                        </h1>
                        <form
                            className="mb-4"
                            onSubmit={(e) => {
                                e.preventDefault();
                                handleStart();
                            }}
                        >
                            <input
                                type="text"
                                name="username"
                                autoComplete="username"
                                value="filtron"
                                readOnly
                                className="sr-only"
                                tabIndex={-1}
                            />

                            <div className="relative">
                                <input
                                    id="login_code"
                                    name="password"
                                    type={showCode ? 'text' : 'password'}
                                    value={loginCode}
                                    onChange={(e) => setLoginCode(e.target.value)}
                                    onKeyDown={handleKeyPress}
                                    className="w-full rounded p-2 pr-10"
                                    placeholder="Please enter access code"
                                    style={{
                                        background: 'rgba(255,255,255,0.12)',
                                        border: '1px solid rgba(255,255,255,0.3)',
                                        color: '#fff',
                                        outline: 'none',
                                    }}
                                    autoComplete="current-password"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowCode((v) => !v)}
                                    className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-300 hover:text-white"
                                    aria-label={showCode ? 'Hide security code' : 'Show security code'}
                                >
                                    {showCode ? <FaEyeSlash /> : <FaEye />}
                                </button>
                            </div>
                        </form>
                        <button
                            onClick={handleStart}
                            disabled={!loginCode.trim()}
                            className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:bg-blue-300"
                        >
                            Start
                        </button>
                    </div>
                </main>
                <Footer />
            </div>
        </div>
    );
}
